export enum LifecycleColors {
	PRIMARY = 'var(--color-lifecycle-primary)',
	PRIMARY900 = 'var(--color-lifecycle-primary-900)',
	PRIMARY800 = 'var(--color-lifecycle-primary-800)',
	PRIMARY700 = 'var(--color-lifecycle-primary-700)',
	PRIMARY600 = 'var(--color-lifecycle-primary-600)',
	PRIMARY500 = 'var(--color-lifecycle-primary-500)',
	PRIMARY400 = 'var(--color-lifecycle-primary-400)',
	PRIMARY300 = 'var(--color-lifecycle-primary-300)',
	PRIMARY200 = 'var(--color-lifecycle-primary-200)',
	PRIMARY100 = 'var(--color-lifecycle-primary-100)',
}
